<template>
  <div
      class="card-statistics card cursor-pointer"
      v-on:click="handleClick"
  >
    <div class="card-header">
      <h4 class="card-title">
        Vencen
      </h4>
      <p class="card-text font-small-2 me-25 mb-0 text-primary">
        Entre {{ from }} a {{ to }} dias
      </p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="mb-2 mb-xl-0 col">
          <div class="d-flex align-items-center">
            <div class="avatar me-2 bg-light-primary">
              <span class="avatar-content">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                  <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                  <polyline points="17 6 23 6 23 12"></polyline>
                </svg>
              </span>
            </div>
            <div
                class="ml-auto "
                style="text-align: right"
            >
              <h4 class="fw-bolder mb-0">{{ total }}</h4>
              <p class="font-small-3 mb-0 card-text">Expedientes</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { ioIndicadoresExpedientesSearch } from '@/febos/servicios/api/busqueda.api';
import { STATES } from '@/febos/chile/dnt/mixins/EdFilesExpStates';

export default {
  name: 'VencenEnXDias',
  props: {
    id: {
      type: String,
      required: true
    },
    from: {
      type: Number,
      required: true
    },
    to: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      total: 0
    };
  },
  computed: {
    extraFilters() {
      return `estado:${STATES.IN_PROGRESS.id
      },${STATES.JOINED.id
      },${STATES.IN_FLOW.id
      },${STATES.APPROVED.id
      },${STATES.REJECTED.id
      },${STATES.MANAGED.id
      },${STATES.NUMBERED.id
      }|fechaVencimiento:${
          this.from !== undefined ? Vue.moment().add('days', this.from).format('YYYY-MM-DD') : ''
      }--${
          this.to !== undefined ? Vue.moment().add('days', this.to).format('YYYY-MM-DD') : ''
      }`;
    }
  },
  methods: {
    async loadIndicator(filter) {
      const filterWithDateWxpired = `${filter}|${this.extraFilters}`;
      const { data: { datos } } = await ioIndicadoresExpedientesSearch(
        {
          filtros: filterWithDateWxpired
        }
      );
      this.total = datos.total;
    },
    handleClick() {
      // emitir evento para que se muestre el modal de filtro de fechas
      this.$emit('selected-card', { id: this.id, filters: this.extraFilters });
    }
  }
};
</script>

<style lang="scss">
.card-body {
  position: relative;

  .pie-text {
    width: 105px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 44%;
    bottom: 0;
  }
}
</style>
